import api from "../../index";

export const GetMaintenanceStatusApi = () => api.get('Maintenance/Get-MaintenanceMode-Status');
export const GetContactStatusApi = () => api.get('Admin/TurnOnOff-MobileNo-IBTree-Status');
export const TurnOnOffMobileNoOfIBTreeApi = (data) => api.patch('Admin/TurnOnOff-MobileNo-IBTree', data);
export const TurnOnOffMaintenanceApi = (params) => api.post(`Maintenance/Enable-Disable-MaintenanceMode?${params}`);
export const UpdateParentVisibilityApi = (userId, params) => api.patch(`UserMaster/update-parent-detail-show-status/${userId}?${params}`);
export const Request2faChangeApi = (isEnable) => api.put(`UserMaster/google-auth?enable=${isEnable}`);
export const ForgetOtp2FAApi = (data) => api.put('UserMaster/verify-auth-disabled', data);